import { render, staticRenderFns } from "./skor_presensi.vue?vue&type=template&id=19f0983c"
import script from "./skor_presensi.vue?vue&type=script&lang=js"
export * from "./skor_presensi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports